import React from 'react';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import _CountUp from 'react-countup';

const CountUp = observer(_CountUp);

const TotalMessages = inject('store')(observer(({ store = {} }) => {
    const val = store.totalMessagesCounter && store.totalMessagesCounter || 0;
    // const prevVal = store.prevTotalMessagesCounter && store.prevTotalMessagesCounter || 0;
    return val.toLocaleString();
}));

export default TotalMessages;



// WEBPACK FOOTER //
// ./src/app/components/TotalMessages.js